import React from 'react';

const NotificationSkeleton: React.FC = () => {
  return (
    <div className="flex items-start gap-4 border-b py-4">
      <div className="skeleton-block rounded-lg" style={{ width: 32, height: 32 }} />
      <div className="grow">
        <div className="mb-2 flex items-center gap-2">
          <div className="skeleton-block rounded-lg" style={{ width: 160, height: 20 }} />
          <div className="skeleton-block ml-4 rounded-lg" style={{ width: 96, height: 16 }} />
        </div>
        <div className="skeleton-block mb-2 w-full rounded-lg" style={{ height: 16 }} />
        <div className="skeleton-block rounded-lg" style={{ width: '75%', height: 16 }} />
      </div>
    </div>
  );
};

export default NotificationSkeleton;
